import { Box } from '@material-ui/core';
import React from 'react';

import { Button } from '../core/button/Button';
import styles from './FooterBanner.module.css';
interface Props {
  communityInfo: any;
  bannerImage: string;
}

export const FooterBannerComponent: React.FC<Props> = props => {
  const { communityInfo, bannerImage } = props;

  let linkUrl = '';
  let linkText = '';

  const imageStyle = {
    backgroundImage: `url(${bannerImage.replace(
      'd8r7g9tzupsfa',
      'd2bhvhyqzg9zio',
    )})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };
  if (communityInfo !== '') {
    linkUrl =
      communityInfo.discord ?? communityInfo.twitter ?? communityInfo.website;
    linkText = communityInfo.discord
      ? 'Discord'
      : communityInfo.twitter
      ? 'Twitter'
      : communityInfo.website
      ? 'Website'
      : '';
  }

  const linkHandler = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      component="span"
      className={`flex flex-col text-center md:text-left h-full`}
      style={imageStyle}
    >
      {communityInfo && (
        <div className="md:w-1/3 py-5 px-2 sm:px-20">
          <div className={`${styles.bannerTitle} py-5 sm:py-10`}>
            {communityInfo.title}
          </div>
          <div className="pb-10">{communityInfo.description}</div>
          <div className="pb-10">
            {linkText !== '' && (
              <Button
                className=""
                onClick={() => linkHandler(linkUrl)}
                label={`Join Our ${linkText}`}
              />
            )}
          </div>
        </div>
      )}
    </Box>
  );
};
